import Swal from 'sweetalert2';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isToday from 'dayjs/plugin/isToday';
import { twMerge } from 'tailwind-merge';

dayjs.extend(customParseFormat);
dayjs.extend(isToday);

export const showToast = ({ icon, title, footer, image, position = 'bottom-start', props }) => {
  const Toast = Swal.mixin({
    toast: true,
    position,
    showConfirmButton: false,
    timer: 3000,
    customClass: {
      title: 'truncate_title',
      container: 'swap !z-[99999]',
    },
    padding: '10px 10px',
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  });

  Toast.fire({
    imageUrl: image,
    icon,
    title,
    footer,
    ...props,
  });
};

export const getContentKeyAccToLang = (data, key, isArabic) => {
  if (data) {
    if (isArabic) return data[key + '_arabic'];
    return data[key] ?? '';
  }
  return '';
};

export const setToken = (token) => localStorage.setItem('corporate_oao_token', token);

export const getToken = () => localStorage.getItem('corporate_oao_token');

export const formatNumbers = (value, digit = 2) => {
  let num = Number(value);

  if (isNaN(num) || value === null || value === undefined) {
    return (0).toFixed(digit);
  }

  const [intPart, decPart = ''] = num.toString().split('.');

  // Format integer part with commas
  const formattedInt = Number(intPart).toLocaleString('en-US');

  // Truncate decimal without rounding
  const truncatedDec = decPart.slice(0, digit).padEnd(digit, '0');

  return `${formattedInt}.${truncatedDec}`;
};

export function cn(...classes) {
  return twMerge(classes.filter(Boolean).join(' '));
}

